import { connect, useDispatch } from "react-redux"
import { reduxForm } from "redux-form"
import { editUser } from "../../../actions/users"
import UserForm from "../UserForm"

const EditUser = ({ submitting, handleSubmit, valid, onSuccess }) => {
  const dispatch = useDispatch()

  const onSubmit = async (data) => {
    dispatch(editUser(data, onSuccess))
  }

  return (
    <UserForm
      submitting={submitting}
      valid={valid}
      isEdit={true}
      handleSubmit={handleSubmit(onSubmit)} />
  )
}

export default connect((state, ownProps) => {
  return {
    initialValues: {
      ...ownProps.info
    }
  }
}, null)(reduxForm({
  form: 'edit-user-form',
  enableReinitialize: true
})(EditUser))